import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 .75a1.5 1.5 0 0 0-1.5 1.5v2.367a7.5 7.5 0 0 0 15 0V2.25A1.5 1.5 0 0 0 18 .75Z"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 23.25a1.5 1.5 0 0 1-1.5-1.5v-2.367a7.5 7.5 0 0 1 15 0v2.367a1.5 1.5 0 0 1-1.5 1.5Zm-.523-15h13.046"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.548 23.147C17.264 20.451 14.813 18 12 18s-5.264 2.451-6.548 5.147"
    }, null, -1)
  ]));
}
const interfaceTimeHourGlass = { render };
export {
  interfaceTimeHourGlass as default,
  render
};
//# sourceMappingURL=interface-time-hour-glass.svg.js.map
